import React from 'react';
import DetailOrganizeReorderPanel from './DetailOrganizeReorderPanel';

export default function ProgramSlotsEditorPanel({
  visible,
  slots = [],
  inputStyle,
  actionBtnStyle,
  newSlotName = '',
  onNewSlotNameChange,
  onAddSlot,
  onDragStart,
  onDrop,
  onDragEnd,
  onMoveUp,
  onMoveDown,
  onRemove,
  editingSlotIndex = null,
  onStartEditingSlot,
  onChangeSlotName,
  onCommitSlotName,
  onCancelEditingSlot,
}) {
  return (
    <DetailOrganizeReorderPanel
      visible={visible}
      items={slots}
      inputStyle={inputStyle}
      actionBtnStyle={actionBtnStyle}
      onDragStart={onDragStart}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      onMoveUp={onMoveUp}
      onMoveDown={onMoveDown}
      onRemove={onRemove}
      renderItemLabel={(slot, index) => (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', width: '100%' }}>
          <span style={{ color: 'var(--text-muted)', minWidth: '24px' }}>{index + 1}.</span>
          {editingSlotIndex === index ? (
            <input
              className="search-input"
              style={{ ...(inputStyle || {}), maxWidth: '360px', width: '100%' }}
              value={slot?.name || ''}
              onChange={(e) => onChangeSlotName?.(index, e.target.value)}
              onBlur={() => onCommitSlotName?.(index, slot?.name || '')}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  onCommitSlotName?.(index, slot?.name || '');
                }
                if (e.key === 'Escape') {
                  onCancelEditingSlot?.();
                }
              }}
              autoFocus
            />
          ) : (
            <span
              style={{ cursor: 'text' }}
              onClick={(e) => {
                e.stopPropagation();
                onStartEditingSlot?.(index);
              }}
              title="Click to rename slot"
            >
              {slot?.name || 'Untitled slot'}
            </span>
          )}
        </span>
      )}
      getItemKey={(slot, index) => `slot-${index}-${slot?.name || ''}`}
      customSearchRow={(
        <div className="organizer-row-two" style={{ alignItems: 'center' }}>
          <input
            className="search-input"
            style={{ ...(inputStyle || {}), width: '100%', boxSizing: 'border-box' }}
            value={newSlotName}
            onChange={(e) => onNewSlotNameChange?.(e.target.value)}
            placeholder="Slot name (e.g. Opening tune)"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                onAddSlot?.();
              }
            }}
          />
          <button
            className="btn-subtle search-control-btn"
            style={{
              ...(actionBtnStyle || {})
            }}
            onClick={onAddSlot}
          >
            + Add Slot
          </button>
        </div>
      )}
      hideAvailableList
    />
  );
}
